import {
  DefaultBanner,
  DefaultBannerContent,
  LinkCta,
  LinkCtaNoir,
  LoadingBanner,
  MembershipCheckoutBanner,
  MembershipCtaBanner,
  ReferFriendSideLink,
} from 'Blocks/Banner/BannerComponents';

import GiftWithPurchaseBanner from 'Apps/PromotionTerms/Scenes/GiftWithPurchase/GiftWithPurchaseBanner';
import { matchPath } from 'react-router-dom';
import * as bannerContent from 'assets/content/banner';

export const defaultBanner = {
  shouldRender: () => true, // This should always return true
  render: hideBannerLink => (
    <DefaultBanner data-testid="banner" props={{ hasLink: !hideBannerLink }}>
      <DefaultBannerContent />
      {!hideBannerLink && <ReferFriendSideLink />}
    </DefaultBanner>
  ),
};

export const noFreeShippingContent = {
  shouldRender: ({ hasNoFreeShipping }) => hasNoFreeShipping,
  render: hideBannerLink => (
    <DefaultBanner data-testid="banner" props={{ hasLink: !hideBannerLink }}>
      <span data-testid="no-free-shipping-content-banner">
        {bannerContent.noFreeShippingContent}
      </span>
      {!hideBannerLink && <ReferFriendSideLink />}
    </DefaultBanner>
  ),
};

export const referralCta = {
  shouldRender: ({ haveSubscription }) => haveSubscription,
  render: () => (
    <DefaultBanner data-testid="banner">
      <LinkCta
        data-click="refer"
        data-from="banner"
        data-testid="referral-cta-banner"
        to="/account/refer-a-friend"
      >
        {bannerContent.referralCta}
      </LinkCta>
    </DefaultBanner>
  ),
};

export const membershipCheckout = {
  shouldRender: ({ canSubscribeAtCart, locationPathname }) =>
    canSubscribeAtCart && matchPath('/checkout', locationPathname),
  render: () => (
    <MembershipCheckoutBanner data-testid="membership-checkout-banner">
      <span>{bannerContent.membershipCheckout}</span>
    </MembershipCheckoutBanner>
  ),
};

export const giftWithPurchase = {
  shouldRender: ({ isGiftWithPurchaseEligible, giftWithPurchaseBannerData }) =>
    isGiftWithPurchaseEligible && Boolean(giftWithPurchaseBannerData),
  render: (_hideBannerLink, options) => (
    <GiftWithPurchaseBanner
      backgroundColor={options.giftWithPurchaseBannerData.banner_color}
      redirectionUrl={options.giftWithPurchaseBannerData.banner_redirection_url}
      text={options.giftWithPurchaseBannerData.banner_text}
    />
  ),
};

export const membershipCta = {
  shouldRender: ({ canSubscribe }) => canSubscribe,
  render: hideBannerLink => (
    <MembershipCtaBanner data-testid="banner" props={{ hasLink: !hideBannerLink }}>
      <LinkCtaNoir
        data-click="membership-lp-prospects"
        data-from="banner"
        data-testid="membership-cta"
        to="/the-salon"
      >
        {bannerContent.membershipCta}
      </LinkCtaNoir>
      {!hideBannerLink && <ReferFriendSideLink />}
    </MembershipCtaBanner>
  ),
};

export const loading = {
  shouldRender: ({ isFlagsDoneFetching }) => !isFlagsDoneFetching,
  render: () => <LoadingBanner data-testid="loading-banner" />,
};

export const vanityUrlDailypop = {
  shouldRender: ({ showVanityUrl }) => showVanityUrl,
  render: () => (
    <DefaultBanner data-testid="vanity-url-banner">
      <span style={{ paddingTop: '2px' }}>{bannerContent.vanityUrlDailypop}</span>
    </DefaultBanner>
  ),
};

export const supplementsPages = {
  shouldRender: ({ locationPathname, isAuthenticated }) =>
    !isAuthenticated &&
    (matchPath('/pages/supplements', locationPathname) ||
      matchPath('/products/custom-hair-supplements', locationPathname)),
  render: () => (
    <DefaultBanner data-testid="banner">
      <LinkCta
        data-click="membership-lp-prospects"
        data-from="banner"
        data-testid="membership-cta"
        to="/the-salon"
      >
        {bannerContent.membershipCta}
      </LinkCta>
    </DefaultBanner>
  ),
};
